import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
import { ToastContainer, toast } from "react-toastify";
import Cancel from "./../../../../assets/icons/close.png";

import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal.js";
import axios from "axios";
import jwtDecode from "jwt-decode";
import LoadingView from "../../../components/LoadingView/LoadingView.js";

function EditKitchenDialog(props) {
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);

  const [selectedRestaurantDatas, setSelectedRestaurantDatas] = useState(null);

  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);

  const handleClose = () => {
    setopenConfirmaitonModal(false);
    props.onHandleAddItem(false);
  };

  const [kitchenName, setKitchenName] = useState("");
  const [resturentId, setResturentId] = useState("");
  const [printerIpAddress, setPrinterIpAddress] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [emailAddress, setEmailAddress] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [maxQueuedSize, setMaxQueuedSize] = useState("");
  const [queuedMaxTime, setQueuedMaxTime] = useState("");
  const [loadingModal, SetloadingModal] = React.useState(false);
  const apiAddress = process.env.REACT_APP_SECRET;

  const loadData = async () => {
    axios({
      method: "get",
      url: apiAddress + "/api/Kitchen/" + props.selectedId,
    })
      .then((response) => {
        var kitchenData = response.data;

        setKitchenName(kitchenData.name);
        setResturentId(kitchenData.restaurantId);
        setPrinterIpAddress(kitchenData.printerIpAddress);
        setIsDefault(kitchenData.isDefault);
        setIsActive(kitchenData.isActive);
        setEmailAddress(kitchenData.emailAddress);
        setMobileNo(kitchenData.mobileNo);
        setMaxQueuedSize(kitchenData.maxQueuedSize);
        setQueuedMaxTime(kitchenData.queuedMaxTime);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    loadData();
  }, [props]);

  // const [tokenData, setTokenData] = useState({})

  const update = () => {
    var valid = true;

    if (mobileNo.length != 10 && mobileNo.length != 11) {
      valid = false;
      toast.error("Phone number is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (kitchenName == "" || kitchenName == undefined || kitchenName == null) {
      valid = false;
      toast.error("Kitchen name is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    // if (restaurantName == "" || restaurantName == undefined || restaurantName == null) {
    //     valid = false;
    //     toast.error("Restaurant Name name is not valid", {
    //         position: "top-right",
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "colored",
    //     });
    // }
    if (
      maxQueuedSize == "" ||
      maxQueuedSize == undefined ||
      maxQueuedSize == null
    ) {
      valid = false;
      toast.error("max Queued Size name is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (
      queuedMaxTime == "" ||
      queuedMaxTime == undefined ||
      queuedMaxTime == null
    ) {
      valid = false;
      toast.error("Queued Max Time name is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (
      emailAddress == "" ||
      emailAddress == undefined ||
      emailAddress == null
    ) {
      valid = false;
      toast.error("Email is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
console.log("selectedRestaurantDatas", selectedRestaurantDatas);
    if (valid) {
       SetloadingModal(true);

      axios({
        method: "put",
        url: apiAddress + "/api/kitchen/" + props.selectedId,

        data: {
          id: props.selectedId,
          name: kitchenName,
          restaurantId: selectedRestaurantDatas?.id,
          restaurantName: selectedRestaurantDatas?.title,
          printerIpAddress: printerIpAddress,
          isDefault: isDefault,
          isActive: isActive,
          emailAddress: emailAddress,
          mobileNo: mobileNo,
          maxQueuedSize: maxQueuedSize,
          queuedMaxTime: queuedMaxTime,
        },
      })
        .then((response) => {
          SetloadingModal(false);
          console.log(response);
          toast.success("Successfully Updated", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          setopenConfirmaitonModal(false);
          props.onHandleAddItem(false);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.response, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
    setopenConfirmaitonModal(false);
  };

  const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));

  const [restaurantDatas, setRestaurantDatas] = React.useState([]);

  const token = localStorage.getItem("gotasteadmintoken");
  const [userId, setUserId] = useState();

  const loadRestaurantName = () => {
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwtDecode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) {}
    }

    axios
      // .get(apiAddress + "/api/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=" + decodedData.UserId+"&restaurantId="+Restauranttoken.id)
      .get(
        apiAddress +
          `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
          };
          list.push(obj);
        });
        setRestaurantDatas(list);
      });
  };

  useEffect(() => {
    loadRestaurantName();
  }, []);

  useEffect(() => {
    const foundItem = restaurantDatas.find((item) => item.id === resturentId);
    setSelectedRestaurant(foundItem);
    setSelectedRestaurantDatas(foundItem);
  }, [restaurantDatas, resturentId]);


  const closeLoadingModal = () => {
    SetloadingModal(false);
  };


  return (
    <div>
      <React.Fragment>
        <Dialog
          fullWidth={true}
          open={props.open}
          onClose={handleClose}
          maxWidth={"lg"}
        >
          <LoadingView open={loadingModal} close={closeLoadingModal} />
          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"You want to update this?"}
            open={openConfirmaitonModal}
            onyes={update}
            close={() => {
              setopenConfirmaitonModal(false);
            }}
          />
          <ToastContainer />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>Update Kitchen</DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={handleClose}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <div style={{ padding: "10px" }}>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  kitchen Name
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  label={"kitchen Name"}
                  id="1"
                  value={setKitchenName}
                  val={kitchenName}
                />
              </Grid>
            </Grid>

            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Email Address
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  label={"Email Address"}
                  value={setEmailAddress}
                  val={emailAddress}
                />
              </Grid>
            </Grid>

            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "1rem", gap: "10px" }}
                >
                  <Typography>Restaurant</Typography>
                </div>
              </Grid>
              <Grid item xs={10}>
                {selectedRestaurant?.title ? (
                  <Autocomplete
                    defaultValue={selectedRestaurant}
                    id="restaurant-dropdown"
                    options={restaurantDatas}
                    onChange={(event, newInputValue, reason, detail) => {
                      setSelectedRestaurantDatas(newInputValue);
                    }}
                    className="my-3"
                    getOptionLabel={(option) => option.title}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Restaurant"
                      />
                    )}
                  />
                ) : (
                  ""
                )}
              </Grid>
            </Grid>

            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Mobile Number
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  label={"Mobile Number"}
                  id="3"
                  value={setMobileNo}
                  val={mobileNo}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Max Queued
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  label={"Max Queued"}
                  value={setMaxQueuedSize}
                  val={maxQueuedSize}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Queued Max Time
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  label={"Queued Max Time"}
                  value={setQueuedMaxTime}
                  val={queuedMaxTime}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>Default</Typography>
              </Grid>
              <Grid item xs={9}>
                <Switch
                  value={setIsDefault}
                  val={isDefault}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>Active</Typography>
              </Grid>
              <Grid item xs={9}>
                <Switch
                  checked={isActive}
                  onChange={setIsActive}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={10}></Grid>
              <Grid item xs={2}>
                <Button
                  className="AddItemButtons"
                  onClick={() => setopenConfirmaitonModal(true)}
                >
                  Update
                </Button>
              </Grid>
            </Grid>
          </div>
          {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default EditKitchenDialog;
